/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {NotImported} from '../../../../components/NotInformat'
import {CatalogItemImage} from '../../../../catalogo/components/CatalogItemImage'

type Props = {
  typeServices: any[]
  setMyTypeService: any
  setShowCreateAppModal: any
  setShowCreateAppModalDelete: any
  setShowCreateAppModalDetails: any
}

export function TableBody({
  typeServices,
  setMyTypeService,
  setShowCreateAppModal,
  setShowCreateAppModalDelete,
}: Props) {
  const handleButtonClickDelete = (event: any, typeService: any) => {
    event.stopPropagation()
    setMyTypeService(typeService)
    setShowCreateAppModalDelete(true)
  }

  const handleButtonClickUpdate = (event: any, typeService: any) => {
    event.stopPropagation()
    typeService.idsUnitBranch =
      typeService.unitBranchs?.length > 0
        ? typeService.unitBranchs.map((unitBranch: any) => unitBranch.id)
        : []
    setMyTypeService(typeService)
    setShowCreateAppModal(true)
  }

  return (
    <tbody>
      {typeServices && typeServices.length !== 0 ? (
        typeServices.map((typeService: any) => {
          return (
            <tr key={typeService.id}>
              <td>
                <div className='d-flex align-items-center'>
                  <div className='me-4'>
                    <CatalogItemImage
                      imageKey={typeService.image}
                      fallbackIcon='/media/icons/duotune/general/gen016.svg'
                    />
                  </div>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='text-dark fw-bold text-hover-primary fs-6'>
                      {typeService.description || 'Sem nome'}
                    </span>
                    <span className='text-muted fw-semibold d-block fs-7'>
                      {typeService.details || 'Sem descrição'}
                    </span>
                  </div>
                </div>
              </td>

              <td>
                <span className='text-dark fw-bold fs-6'>
                  {typeService.preco != null ? (
                    `R$ ${Number(typeService.preco).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  ) : (
                    <NotImported className='fs-5 fw-bolder' />
                  )}
                </span>
              </td>

              <td>
                <div className='d-flex justify-content-end flex-shrink-0'>
                  <a
                    onClick={(event: any) => handleButtonClickUpdate(event, typeService)}
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a>
                  <a
                    onClick={(event: any) => handleButtonClickDelete(event, typeService)}
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                  </a>
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={3} style={{textAlign: 'center'}}>
            <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
              <span className='text-muted fw-semibold d-block fs-4'>
                Nenhum serviço encontrado
              </span>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  )
}
